import classNames from 'classnames';
import React, { useMemo } from 'react';
// @ts-ignore TODO LATER FIX IMPLICIT ANY
import Lottie from 'react-lottie-wrapper';

import { memoizedComponent } from 'utils/memoizeComponent';

import { LottieProps, Options } from './types';

type Props = LottieProps & {
  className?: string;
};

export const Animation: React.FC<React.PropsWithChildren<Props>> = memoizedComponent(
  ({ className = '', height, width, options, isPaused, isStopped }: Props) => {
    const animationClassNames = classNames({
      animation: true,
      [className]: className,
    });

    const defaultOptions: Options = useMemo(
      () => ({
        loop: false,
        autoplay: true,
        rendererSettings: {},
        ...options,
      }),
      [options],
    );

    return (
      <div className={animationClassNames}>
        <Lottie
          options={defaultOptions}
          ariaLabel=''
          height={height}
          width={width}
          isPaused={isPaused}
          isStopped={isStopped}
        />
      </div>
    );
  },
);
